import { useState, useContext, useEffect } from 'react';
import { Textbox, Button } from 'components/generic';
import { OnboardingContext } from 'providers/onboarding-provider';
import { useNavigate } from 'react-router-dom';
import { useFetch } from 'hooks';

const ResetPassword = () => {
	const { setSignupToggler, resetPwdStatus, reset } = useContext(OnboardingContext);
	const [resetObj, setResetObj] = useState({});
	const [buttonDisable, setButtonDisable] = useState(true);

	const navigate = useNavigate();
	const api = useFetch();

	const handleResetData = (e, key) => {
		setResetObj(prevState => ({ ...prevState, [key]: e }));
	};

	const handleReset = async () => {
		const payload = { c_id: resetPwdStatus?.id, c_username: resetPwdStatus?.username, c_password: resetObj?.c_password, token: resetPwdStatus?.token };
		resetPwdStatus ? await api({ url: `client/v1/updatePassword`, method: 'post', successToaster: true, data: payload }) : await api({ url: `client/v1/resetPassword/${resetObj?.c_username}`, method: 'get', successToaster: true });
		reset();
		navigate('', { replace: true });
	};

	useEffect(() => {
		setButtonDisable(resetPwdStatus ? resetObj?.c_password !== resetObj?.c_confirmPassword || !resetObj?.c_password : !resetObj?.c_username);
	}, [resetPwdStatus, resetObj]);

	return (
		<div className='client-login'>
			<h1>Reset Password</h1>
			{resetPwdStatus ? (
				<>
					<Textbox label='New Password' infoContent='Enter New Password' type='password' mandatory placeholder='Enter new password' value={resetObj?.c_password} id='reset_pwd1' onChange={e => handleResetData(e?.target?.value, 'c_password')} />
					<Textbox label='Confirm Password' infoContent='Enter Confirm Password' type='password' mandatory placeholder='Enter new password' value={resetObj?.c_confirmPassword} id='reset_pwd2' onChange={e => handleResetData(e?.target?.value, 'c_confirmPassword')} />
				</>
			) : (
				<>
					<Textbox label='Username' infoContent='Enter Username' mandatory placeholder='Enter username' value={resetObj?.c_username} id='reset_pwd' onChange={e => handleResetData(e?.target?.value, 'c_username')} />
					<span className='flex-end hyperlink' onClick={() => setSignupToggler('SIGNIN')}>
						Back to login
					</span>
				</>
			)}
			<Button label='Reset Password' disabled={buttonDisable} primary full handleOnSubmit={handleReset} />
		</div>
	);
};

export default ResetPassword;
